import * as React from "react";
import { Box } from "@mui/material";

/**
 * OverlappedImagePair
 * - Two images: a "base" image (left/back) and a "top" image (right/front)
 * - No background — only images
 * - Optional shared border (or separate border overrides)
 */
export default function OverlappedImagePair({
                                                primarySrc,
                                                secondarySrc,
                                                primaryAlt = "",
                                                secondaryAlt = "",

                                                // Layout
                                                height,
                                                primaryWidth = "68%",     // how much space the base image occupies
                                                secondaryWidth = "46%",   // how large the top image is
                                                secondaryAnchor = { top: "14%", right: 0 }, // where the top image is placed
                                                secondaryTransform = "rotate(2deg)",        // slight tilt like the reference
                                                gap = 16,                // affects breathing room on small screens

                                                // Styling
                                                borderRadius = 16,
                                                border, // e.g. "1px solid rgba(0,0,0,0.12)" OR { primary, secondary }
                                                boxShadow = "none", // optional, keep "none" if you want purely borders
                                                objectFit = "cover",

                                                // Advanced overrides
                                                containerSx,
                                                primarySx,
                                                secondarySx,
                                                imgProps,
                                            }) {
    const resolvedBorderPrimary =
        typeof border === "object" ? border.primary : border;
    const resolvedBorderSecondary =
        typeof border === "object" ? border.secondary : border;

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                height,
                display: "block",
                ...containerSx,
            }}
        >
            {/* Base / primary */}
            <Box
                component="img"
                src={primarySrc}
                alt={primaryAlt}
                {...imgProps}
                sx={{
                    display: "block",
                    width: primaryWidth,
                    height: "100%",
                    borderRadius,
                    border: resolvedBorderPrimary || "none",
                    boxShadow,
                    objectFit,
                    userSelect: "none",
                    pointerEvents: "none",
                    // keep it responsive-ish
                    maxWidth: "100%",
                    ...primarySx,
                }}
            />

            {/* Top / secondary */}
            <Box
                component="img"
                src={secondarySrc}
                alt={secondaryAlt}
                {...imgProps}
                sx={{
                    position: "absolute",
                    width: secondaryWidth,
                    height: `calc(100% - ${gap}px)`,
                    borderRadius,
                    border: resolvedBorderSecondary || "none",
                    boxShadow,
                    objectFit,
                    transform: secondaryTransform,
                    transformOrigin: "center",
                    userSelect: "none",
                    pointerEvents: "none",
                    ...secondaryAnchor,
                    ...secondarySx,
                }}
            />
        </Box>
    );
}
